"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@ungap/custom-elements");
require("./components/tabs");
require("./styles/recipe.scss");
document.body.addEventListener('click', ({ target }) => {
    if (target instanceof HTMLButtonElement && target.value === 'print') {
        window.print();
    }
});
